export default class Config {
  static readonly GOOOGLE_MAP_API_KEY =
    'AIzaSyDswP272vF5WZVy9n8lBai1df9bbuvzblI';

  static readonly SITE_VISIT_GOOGLE_MAP_API_KEY =
    'AIzaSyCA9hVC_b5uCmRe52zoacskcqqLps35cmw';
}
